import { type ReactNode } from 'react'

export default function FunnelLayout({
  children,
  header,
}: {
  children: ReactNode
  header?: ReactNode
}) {
  return (
    <div className="bg-hw-cream text-hw-ink flex min-h-dvh flex-col">
      {header}

      <main className="hw-container flex grow flex-col">{children}</main>
    </div>
  )
}
